import "./App.css";
import CalculatorForm from "./components/CalculatorForm";
import Results from "./components/Results";
import { DataProvider } from "./components/DataProvider";
import { useRef,useEffect } from "react";
import { motion, useInView, useAnimation } from "framer-motion";

function App() {
  
   
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();

  useEffect(() => {
    mainControls.start("visible"); 
   }, [isInView]);

  
  return (
   <DataProvider>
      <motion.div
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1 },
        }}
        initial="hidden"
        animate={mainControls}
        transition={{ duration:2.5 , ease:'easeIn'}}
      >
      <div ref={ref} className="flex flex-col md:flex md:flex-row  sm:mt-2  justify-center ">
        <CalculatorForm />
        <Results />
      </div>
      </motion.div>
    </DataProvider>
  );
}

export default App;
